import { createI18n } from 'vue-i18n'
import fr from './fr'
import en from './en'
import de from './de'

export const SUPPORTED_LOCALES = ['fr', 'en', 'de']
export const DEFAULT_LOCALE = 'fr'

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    fr,
    en,
    de
  }
})

export function setLocale(locale: string) {
  i18n.global.locale.value = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
}

export function getLocale() {
  return i18n.global.locale.value
}

// Fonction utilitaire pour détecter la langue du navigateur
export function detectBrowserLocale(): string {
  const browserLocale = navigator.language.split('-')[0]
  return SUPPORTED_LOCALES.includes(browserLocale) ? browserLocale : DEFAULT_LOCALE
}

export default i18n 